import vehicleTypeService from '../../api/vehicleTypeService'

const state = {
    vehicleTypes: [],
    editVehicleType: null,
    editId: null
}
const getters = {
    vehicleTypes: state => state.vehicleTypes,
    editVehicleType: state => state.editVehicleType
}
const actions = {
    async getVehicleTypes({ commit }) {
        const response = await vehicleTypeService.getVehicleTypes();
        commit('getVehicleTypes', response.data)
    },
    async deleteVehicleType({ commit }, vehicleType) {
        await vehicleTypeService.removeVehicleType(vehicleType.id);
        commit('delete', vehicleType)
    },
    async getVehicleTypeById({ commit }, vehicleType) {
        const response = await vehicleTypeService.getVehicleTypeById(vehicleType.id)
        commit('edit', response.data)
    },
    async addVehicleType({ commit }, vehicleType) {
        await vehicleTypeService.addVehicleType(vehicleType)
        commit('add', vehicleType)
    },
    async updateVehicleType({ commit }, vehicleType) {
        await vehicleTypeService.updateVehicleType(state.editId, vehicleType)
        commit('update', vehicleType)
    }
}
const mutations = {
    getVehicleTypes(state, vehicleTypes) {
        state.vehicleTypes = vehicleTypes
    },
    delete(state, vehicleType) {
        var vehicleTypes = state.vehicleTypes
        const index = vehicleTypes.map(item => item.id).indexOf(vehicleType.id)
        vehicleTypes.splice(index, 1)
    },
    edit(state, vehicleType) {
        state.editId = vehicleType.id
        state.editVehicleType = vehicleType
    },
    add(state, vehicleType) {
        state.vehicleTypes.push(vehicleType);
    },
    update(state, vehicleType) {
        const index = state.vehicleTypes.map(item => item.id).indexOf(state.editId)
        state.vehicleTypes.splice(index, 1)
        state.vehicleTypes.push(vehicleType)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}




